import {BehaviorSubject, Observable} from 'rxjs';

export class AccessRights {
    private userRight_RIS2_RESTORE_PRODUCTSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_RESTORE_PRODUCT$: Observable<boolean> = this.userRight_RIS2_RESTORE_PRODUCTSubject.asObservable();

    private userRight_RIS2_CREATE_PRODUCTSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_CREATE_PRODUCT$: Observable<boolean> = this.userRight_RIS2_CREATE_PRODUCTSubject.asObservable();

    private userRight_RIS2_DELETE_PRODUCTSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_DELETE_PRODUCT$: Observable<boolean> = this.userRight_RIS2_DELETE_PRODUCTSubject.asObservable();

    private userRight_RIS2_EDIT_PRODUCTSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_PRODUCT$: Observable<boolean> = this.userRight_RIS2_EDIT_PRODUCTSubject.asObservable();

    private userRight_RIS2_MANAGE_SUBSCRIPTIONS_PRODUCTSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_MANAGE_SUBSCRIPTIONS_PRODUCT$: Observable<boolean> = this.userRight_RIS2_MANAGE_SUBSCRIPTIONS_PRODUCTSubject.asObservable();

    private userRight_RIS2_CREATE_VERSIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_CREATE_VERSION$: Observable<boolean> = this.userRight_RIS2_CREATE_VERSIONSubject.asObservable();

    private userRight_RIS2_DELETE_VERSIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_DELETE_VERSION$: Observable<boolean> = this.userRight_RIS2_DELETE_VERSIONSubject.asObservable();

    private userRight_RIS2_EDIT_VERSIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_VERSION$: Observable<boolean> = this.userRight_RIS2_EDIT_VERSIONSubject.asObservable();

    private userRight_RIS2_EMAIL_VERSIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EMAIL_VERSION$: Observable<boolean> = this.userRight_RIS2_EMAIL_VERSIONSubject.asObservable();

    private userRight_RIS2_CREATE_NOTESubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_CREATE_NOTE$: Observable<boolean> = this.userRight_RIS2_CREATE_NOTESubject.asObservable();

    private userRight_RIS2_DELETE_NOTESubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_DELETE_NOTE$: Observable<boolean> = this.userRight_RIS2_DELETE_NOTESubject.asObservable();

    private userRight_RIS2_EDIT_NOTESubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_NOTE$: Observable<boolean> = this.userRight_RIS2_EDIT_NOTESubject.asObservable();

    private userRight_RIS2_ARTEFACT_VERSIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_ARTEFACT_VERSION$: Observable<boolean> = this.userRight_RIS2_ARTEFACT_VERSIONSubject.asObservable();

    private userRight_RIS2_ENTITY_OVERVIEWSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_ENTITY_OVERVIEW$: Observable<boolean> = this.userRight_RIS2_ENTITY_OVERVIEWSubject.asObservable();

    private userRight_RIS2_APP_VERSION_OVERVIEWSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_APP_VERSION_OVERVIEW$: Observable<boolean> = this.userRight_RIS2_APP_VERSION_OVERVIEWSubject.asObservable();

    private userRight_RIS2_EDIT_PRODUCT_TRANSLATIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_PRODUCT_TRANSLATION$: Observable<boolean> = this.userRight_RIS2_EDIT_PRODUCT_TRANSLATIONSubject.asObservable();

    private userRight_RIS2_EDIT_VERSION_TRANSLATIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_VERSION_TRANSLATION$: Observable<boolean> = this.userRight_RIS2_EDIT_VERSION_TRANSLATIONSubject.asObservable();

    private userRight_RIS2_EDIT_NOTE_TRANSLATIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_NOTE_TRANSLATION$: Observable<boolean> = this.userRight_RIS2_EDIT_NOTE_TRANSLATIONSubject.asObservable();

    private userRight_RIS2_MANAGEMENT_ENV_ACCESSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_MANAGEMENT_ENV_ACCESS$: Observable<boolean> = this.userRight_RIS2_MANAGEMENT_ENV_ACCESSSubject.asObservable();

    private userRight_RIS2_ACCESS_DEVELOPER_TEXTSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_ACCESS_DEVELOPER_TEXTS$: Observable<boolean> = this.userRight_RIS2_ACCESS_DEVELOPER_TEXTSSubject.asObservable();

    private userRight_RIS2_ACCESS_LOGSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_ACCESS_LOGS$: Observable<boolean> = this.userRight_RIS2_ACCESS_LOGSSubject.asObservable();

    private userRight_RIS2_EXPORT_TRANSLATION_VERSIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EXPORT_TRANSLATION_VERSION$: Observable<boolean> = this.userRight_RIS2_EXPORT_TRANSLATION_VERSIONSubject.asObservable();

    private userRight_RIS2_IMPORT_TRANSLATION_VERSIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_IMPORT_TRANSLATION_VERSION$: Observable<boolean> = this.userRight_RIS2_IMPORT_TRANSLATION_VERSIONSubject.asObservable();

    private userRight_RIS2_VISIBILITY_DEVSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_VISIBILITY_DEV$: Observable<boolean> = this.userRight_RIS2_VISIBILITY_DEVSubject.asObservable();

    private userRight_RIS2_VISIBILITY_SERVICESubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_VISIBILITY_SERVICE$: Observable<boolean> = this.userRight_RIS2_VISIBILITY_SERVICESubject.asObservable();

    private userRight_RIS2_VISIBILITY_CUSTOMERSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_VISIBILITY_CUSTOMER$: Observable<boolean> = this.userRight_RIS2_VISIBILITY_CUSTOMERSubject.asObservable();

    private userRight_RIS2_EDIT_DEV_TEXTSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_DEV_TEXTS$: Observable<boolean> = this.userRight_RIS2_EDIT_DEV_TEXTSSubject.asObservable();

    private userRight_RIS2_EDIT_DISPLAY_NOTE_TYPESubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_DISPLAY_NOTE_TYPE$: Observable<boolean> = this.userRight_RIS2_EDIT_DISPLAY_NOTE_TYPESubject.asObservable();

    private userRight_RIS2_EDIT_VISIBILITY_NOTESSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_VISIBILITY_NOTES$: Observable<boolean> = this.userRight_RIS2_EDIT_VISIBILITY_NOTESSubject.asObservable();

    private userRight_RIS2_EDIT_VISIBILITY_VERSIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_VISIBILITY_VERSION$: Observable<boolean> = this.userRight_RIS2_EDIT_VISIBILITY_VERSIONSubject.asObservable();

    private userRight_RIS2_EDIT_VISIBILITY_PRODUCTSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_VISIBILITY_PRODUCT$: Observable<boolean> = this.userRight_RIS2_EDIT_VISIBILITY_PRODUCTSubject.asObservable();

    private userRight_RIS2_EDIT_PRODUCT_CLIENT_SETTINGSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_PRODUCT_CLIENT_SETTINGS$: Observable<boolean> = this.userRight_RIS2_EDIT_PRODUCT_CLIENT_SETTINGSSubject.asObservable();

    private userRight_RIS2_FVM_ACCESSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_FVM_ACCESS$: Observable<boolean> = this.userRight_RIS2_FVM_ACCESSSubject.asObservable();

    private userRight_RIS2_ACCESS_ENTITY_DETAILSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_ACCESS_ENTITY_DETAILS$: Observable<boolean> = this.userRight_RIS2_ACCESS_ENTITY_DETAILSSubject.asObservable();

    private userRight_RIS2_IMPORT_TRANSLATION_PRODUCTSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_IMPORT_TRANSLATION_PRODUCT$: Observable<boolean> = this.userRight_RIS2_IMPORT_TRANSLATION_PRODUCTSubject.asObservable();

    private userRight_RIS2_EXPORT_TRANSLATION_PRODUCTSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EXPORT_TRANSLATION_PRODUCT$: Observable<boolean> = this.userRight_RIS2_EXPORT_TRANSLATION_PRODUCTSubject.asObservable();

    private userRight_RIS2_ACCESS_DEVELOPMENT_NOTE_TYPESubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_ACCESS_DEVELOPMENT_NOTE_TYPE$: Observable<boolean> = this.userRight_RIS2_ACCESS_DEVELOPMENT_NOTE_TYPESubject.asObservable();

    private userRight_RIS2_ACCESS_PRODUCT_DETAILSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_ACCESS_PRODUCT_DETAILS$: Observable<boolean> = this.userRight_RIS2_ACCESS_PRODUCT_DETAILSSubject.asObservable();

    private userRight_RIS2_ACCESS_VERSION_DETAILSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_ACCESS_VERSION_DETAILS$: Observable<boolean> = this.userRight_RIS2_ACCESS_VERSION_DETAILSSubject.asObservable();

    private userRight_RIS2_ACCESS_NOTE_DETAILSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_ACCESS_NOTE_DETAILS$: Observable<boolean> = this.userRight_RIS2_ACCESS_NOTE_DETAILSSubject.asObservable();

    private userRight_RIS2_ACCESS_STATISTICSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_ACCESS_STATISTICS$: Observable<boolean> = this.userRight_RIS2_ACCESS_STATISTICSSubject.asObservable();

    private userRight_RIS2_EDIT_PUBLIC_RELEASE_PRODUCTSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_EDIT_PUBLIC_RELEASE_PRODUCT$: Observable<boolean> = this.userRight_RIS2_EDIT_PUBLIC_RELEASE_PRODUCTSubject.asObservable();

    private userRight_RIS2_PUBLIC_RELEASE_VERSIONSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_PUBLIC_RELEASE_VERSION$: Observable<boolean> = this.userRight_RIS2_PUBLIC_RELEASE_VERSIONSubject.asObservable();

    private userRight_RIS2_ACCESS_ERRORSSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public userRight_RIS2_ACCESS_ERRORS$: Observable<boolean> = this.userRight_RIS2_ACCESS_ERRORSSubject.asObservable();

    private userRights: number[] = [];

    constructor(accessClaim: string) {
        const binaryClaim = accessClaim.split('').map(i => parseInt(i, 16).toString(2).padStart(4, '0')).join('');

        for (let i = 1; i <= binaryClaim.length; i++) {
            if (binaryClaim[i-1] === '1') {
                if (UserRights[i]) {
                    this.userRights.push(i);
                }
            }
        }

        this.userRight_RIS2_RESTORE_PRODUCTSubject.next(binaryClaim.charAt(UserRights.RIS2_RESTORE_PRODUCT - 1) === '1' ? true : false);
        this.userRight_RIS2_CREATE_PRODUCTSubject.next(binaryClaim.charAt(UserRights.RIS2_CREATE_PRODUCT - 1) === '1' ? true : false);
        this.userRight_RIS2_DELETE_PRODUCTSubject.next(binaryClaim.charAt(UserRights.RIS2_DELETE_PRODUCT - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_PRODUCTSubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_PRODUCT - 1) === '1' ? true : false);
        this.userRight_RIS2_MANAGE_SUBSCRIPTIONS_PRODUCTSubject.next(binaryClaim.charAt(UserRights.RIS2_MANAGE_SUBSCRIPTIONS_PRODUCT - 1) === '1' ? true : false);
        this.userRight_RIS2_CREATE_VERSIONSubject.next(binaryClaim.charAt(UserRights.RIS2_CREATE_VERSION - 1) === '1' ? true : false);
        this.userRight_RIS2_DELETE_VERSIONSubject.next(binaryClaim.charAt(UserRights.RIS2_DELETE_VERSION - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_VERSIONSubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_VERSION - 1) === '1' ? true : false);
        this.userRight_RIS2_EMAIL_VERSIONSubject.next(binaryClaim.charAt(UserRights.RIS2_EMAIL_VERSION - 1) === '1' ? true : false);
        this.userRight_RIS2_CREATE_NOTESubject.next(binaryClaim.charAt(UserRights.RIS2_CREATE_NOTE - 1) === '1' ? true : false);
        this.userRight_RIS2_DELETE_NOTESubject.next(binaryClaim.charAt(UserRights.RIS2_DELETE_NOTE - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_NOTESubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_NOTE - 1) === '1' ? true : false);
        this.userRight_RIS2_ARTEFACT_VERSIONSubject.next(binaryClaim.charAt(UserRights.RIS2_ARTEFACT_VERSION - 1) === '1' ? true : false);
        this.userRight_RIS2_ENTITY_OVERVIEWSubject.next(binaryClaim.charAt(UserRights.RIS2_ENTITY_OVERVIEW - 1) === '1' ? true : false);
        this.userRight_RIS2_APP_VERSION_OVERVIEWSubject.next(binaryClaim.charAt(UserRights.RIS2_APP_VERSION_OVERVIEW - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_PRODUCT_TRANSLATIONSubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_PRODUCT_TRANSLATION - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_VERSION_TRANSLATIONSubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_VERSION_TRANSLATION - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_NOTE_TRANSLATIONSubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_NOTE_TRANSLATION - 1) === '1' ? true : false);
        this.userRight_RIS2_MANAGEMENT_ENV_ACCESSSubject.next(binaryClaim.charAt(UserRights.RIS2_MANAGEMENT_ENV_ACCESS - 1) === '1' ? true : false);
        this.userRight_RIS2_ACCESS_DEVELOPER_TEXTSSubject.next(binaryClaim.charAt(UserRights.RIS2_ACCESS_DEVELOPER_TEXTS - 1) === '1' ? true : false);
        this.userRight_RIS2_ACCESS_LOGSSubject.next(binaryClaim.charAt(UserRights.RIS2_ACCESS_LOGS - 1) === '1' ? true : false);
        this.userRight_RIS2_EXPORT_TRANSLATION_VERSIONSubject.next(binaryClaim.charAt(UserRights.RIS2_EXPORT_TRANSLATION_VERSION - 1) === '1' ? true : false);
        this.userRight_RIS2_IMPORT_TRANSLATION_VERSIONSubject.next(binaryClaim.charAt(UserRights.RIS2_IMPORT_TRANSLATION_VERSION - 1) === '1' ? true : false);
        this.userRight_RIS2_VISIBILITY_DEVSubject.next(binaryClaim.charAt(UserRights.RIS2_VISIBILITY_DEV - 1) === '1' ? true : false);
        this.userRight_RIS2_VISIBILITY_SERVICESubject.next(binaryClaim.charAt(UserRights.RIS2_VISIBILITY_SERVICE - 1) === '1' ? true : false);
        this.userRight_RIS2_VISIBILITY_CUSTOMERSubject.next(binaryClaim.charAt(UserRights.RIS2_VISIBILITY_CUSTOMER - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_DEV_TEXTSSubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_DEV_TEXTS - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_DISPLAY_NOTE_TYPESubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_DISPLAY_NOTE_TYPE - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_VISIBILITY_NOTESSubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_VISIBILITY_NOTES - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_VISIBILITY_VERSIONSubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_VISIBILITY_VERSION - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_VISIBILITY_PRODUCTSubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_VISIBILITY_PRODUCT - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_PRODUCT_CLIENT_SETTINGSSubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_PRODUCT_CLIENT_SETTINGS - 1) === '1' ? true : false);
        this.userRight_RIS2_FVM_ACCESSSubject.next(binaryClaim.charAt(UserRights.RIS2_FVM_ACCESS - 1) === '1' ? true : false);
        this.userRight_RIS2_ACCESS_ENTITY_DETAILSSubject.next(binaryClaim.charAt(UserRights.RIS2_ACCESS_ENTITY_DETAILS - 1) === '1' ? true : false);
        this.userRight_RIS2_IMPORT_TRANSLATION_PRODUCTSubject.next(binaryClaim.charAt(UserRights.RIS2_IMPORT_TRANSLATION_PRODUCT - 1) === '1' ? true : false);
        this.userRight_RIS2_EXPORT_TRANSLATION_PRODUCTSubject.next(binaryClaim.charAt(UserRights.RIS2_EXPORT_TRANSLATION_PRODUCT - 1) === '1' ? true : false);
        this.userRight_RIS2_ACCESS_DEVELOPMENT_NOTE_TYPESubject.next(binaryClaim.charAt(UserRights.RIS2_ACCESS_DEVELOPMENT_NOTE_TYPE - 1) === '1' ? true : false);
        this.userRight_RIS2_ACCESS_PRODUCT_DETAILSSubject.next(binaryClaim.charAt(UserRights.RIS2_ACCESS_PRODUCT_DETAILS - 1) === '1' ? true : false);
        this.userRight_RIS2_ACCESS_VERSION_DETAILSSubject.next(binaryClaim.charAt(UserRights.RIS2_ACCESS_VERSION_DETAILS - 1) === '1' ? true : false);
        this.userRight_RIS2_ACCESS_NOTE_DETAILSSubject.next(binaryClaim.charAt(UserRights.RIS2_ACCESS_NOTE_DETAILS - 1) === '1' ? true : false);
        this.userRight_RIS2_ACCESS_STATISTICSSubject.next(binaryClaim.charAt(UserRights.RIS2_ACCESS_STATISTICS - 1) === '1' ? true : false);
        this.userRight_RIS2_EDIT_PUBLIC_RELEASE_PRODUCTSubject.next(binaryClaim.charAt(UserRights.RIS2_EDIT_PUBLIC_RELEASE_PRODUCT - 1) === '1' ? true : false);
        this.userRight_RIS2_PUBLIC_RELEASE_VERSIONSubject.next(binaryClaim.charAt(UserRights.RIS2_PUBLIC_RELEASE_VERSION - 1) === '1' ? true : false);
        this.userRight_RIS2_ACCESS_ERRORSSubject.next(binaryClaim.charAt(UserRights.RIS2_ACCESS_ERRORS - 1) === '1' ? true : false);

    }

    public isUserRightAvailable(usrRight: number) {
        return this.userRights.indexOf(usrRight) >= 0;
    }
}


export enum UserRights {
    // Description: User is able to restore and permanently delete products
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 104
    // Feature Id: 114 Position: 104
    RIS2_RESTORE_PRODUCT = 104,

    // Description: User is able to create products
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 105
    // Feature Id: 115 Position: 105
    RIS2_CREATE_PRODUCT = 105,

    // Description: User is able to delete products
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 106
    // Feature Id: 116 Position: 106
    RIS2_DELETE_PRODUCT = 106,

    // Description: User is able to edit products
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 107
    // Feature Id: 117 Position: 107
    RIS2_EDIT_PRODUCT = 107,

    // Description: User is able to manage subscriptions of a product
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 108
    // Feature Id: 118 Position: 108
    RIS2_MANAGE_SUBSCRIPTIONS_PRODUCT = 108,

    // Description: User is able to create versions
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 109
    // Feature Id: 119 Position: 109
    RIS2_CREATE_VERSION = 109,

    // Description: User is able to delete versions
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 110
    // Feature Id: 120 Position: 110
    RIS2_DELETE_VERSION = 110,

    // Description: User is able to edit versions
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 111
    // Feature Id: 121 Position: 111
    RIS2_EDIT_VERSION = 111,

    // Description: User is able to send version emails
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 112
    // Feature Id: 122 Position: 112
    RIS2_EMAIL_VERSION = 112,

    // Description: User is able to create notes
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 113
    // Feature Id: 123 Position: 113
    RIS2_CREATE_NOTE = 113,

    // Description: User is able to delete notes
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 114
    // Feature Id: 124 Position: 114
    RIS2_DELETE_NOTE = 114,

    // Description: User is able to edit notes
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 115
    // Feature Id: 125 Position: 115
    RIS2_EDIT_NOTE = 115,

    // Description: User is able to download version artefacts
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 116
    // Feature Id: 126 Position: 116
    RIS2_ARTEFACT_VERSION = 116,

    // Description: User is able to open the entity overview
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 117
    // Feature Id: 127 Position: 117
    RIS2_ENTITY_OVERVIEW = 117,

    // Description: User is able to open the app version overview
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 118
    // Feature Id: 128 Position: 118
    RIS2_APP_VERSION_OVERVIEW = 118,

    // Description: User is able to edit translations of product texts
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 119
    // Feature Id: 129 Position: 119
    RIS2_EDIT_PRODUCT_TRANSLATION = 119,

    // Description: User is able to edit translations of version texts
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 120
    // Feature Id: 130 Position: 120
    RIS2_EDIT_VERSION_TRANSLATION = 120,

    // Description: User is able to edit translations of note texts
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 121
    // Feature Id: 131 Position: 121
    RIS2_EDIT_NOTE_TRANSLATION = 121,

    // Description: User is able to access the management enviroment
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 123
    // Feature Id: 132 Position: 123
    RIS2_MANAGEMENT_ENV_ACCESS = 123,

    // Description: User is able to access developer texts
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 124
    // Feature Id: 133 Position: 124
    RIS2_ACCESS_DEVELOPER_TEXTS = 124,

    // Description: User is able to access Logs
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 125
    // Feature Id: 134 Position: 125
    RIS2_ACCESS_LOGS = 125,

    // Description: User is able to export translation files of version texts
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 126
    // Feature Id: 135 Position: 126
    RIS2_EXPORT_TRANSLATION_VERSION = 126,

    // Description: User is able to import translation files of version texts
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 127
    // Feature Id: 136 Position: 127
    RIS2_IMPORT_TRANSLATION_VERSION = 127,

    // Description: User is able to see Data with Visibility Dev
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 128
    // Feature Id: 137 Position: 128
    RIS2_VISIBILITY_DEV = 128,

    // Description: User is able to see Data with Visibility Service
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 129
    // Feature Id: 138 Position: 129
    RIS2_VISIBILITY_SERVICE = 129,

    // Description: User is able to see Data with Visibility Dev
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 130
    // Feature Id: 139 Position: 130
    RIS2_VISIBILITY_CUSTOMER = 130,

    // Description: USer is able to Edit Developer-Texts
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 131
    // Feature Id: 140 Position: 131
    RIS2_EDIT_DEV_TEXTS = 131,

    // Description: User is Able to Edit the Display-NoteType (Not the Development NoteType)
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 132
    // Feature Id: 141 Position: 132
    RIS2_EDIT_DISPLAY_NOTE_TYPE = 132,

    // Description: User is able to edit the Visibility of Notes
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 133
    // Feature Id: 142 Position: 133
    RIS2_EDIT_VISIBILITY_NOTES = 133,

    // Description: User is able to Edit the Visibility of Versions
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 134
    // Feature Id: 143 Position: 134
    RIS2_EDIT_VISIBILITY_VERSION = 134,

    // Description: User is able to Edit Visibility of products
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 135
    // Feature Id: 144 Position: 135
    RIS2_EDIT_VISIBILITY_PRODUCT = 135,

    // Description: User is allowed to change ClientTag and availibility in Client
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 136
    // Feature Id: 145 Position: 136
    RIS2_EDIT_PRODUCT_CLIENT_SETTINGS = 136,

    // Description: User has permission to open the Firmware Version Manager Desktop Tool
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 137
    // Feature Id: 146 Position: 137
    RIS2_FVM_ACCESS = 137,

    // Description: Can request Entities
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 138
    // Feature Id: 147 Position: 138
    RIS2_ACCESS_ENTITY_DETAILS = 138,

    // Description: User is able to import translation files of product texts
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 139
    // Feature Id: 148 Position: 139
    RIS2_IMPORT_TRANSLATION_PRODUCT = 139,

    // Description: User is able to export translation files of product texts
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 140
    // Feature Id: 149 Position: 140
    RIS2_EXPORT_TRANSLATION_PRODUCT = 140,

    // Description: User is access the development Note Type
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 141
    // Feature Id: 150 Position: 141
    RIS2_ACCESS_DEVELOPMENT_NOTE_TYPE = 141,

    // Description: User is access all Product details
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 142
    // Feature Id: 151 Position: 142
    RIS2_ACCESS_PRODUCT_DETAILS = 142,

    // Description: User is access all Version details
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 143
    // Feature Id: 152 Position: 143
    RIS2_ACCESS_VERSION_DETAILS = 143,

    // Description: User is access all Note details
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 144
    // Feature Id: 153 Position: 144
    RIS2_ACCESS_NOTE_DETAILS = 144,

    // Description: User is able to access Statistics
    // ClaimName: AUMA_UMS_USERRIGHTSCLAIM1 Position: 145
    // Feature Id: 154 Position: 145
    RIS2_ACCESS_STATISTICS = 145,

    // Description: User is allowed to change the availability of the product in the Public GUI
    // ClaimName: null Position: 161
    // Feature Id: 161 Position: 161
    RIS2_EDIT_PUBLIC_RELEASE_PRODUCT = 161,

    // Description: User is allowed to release a version to the Public GUI
    // ClaimName: null Position: 162
    // Feature Id: 162 Position: 162
    RIS2_PUBLIC_RELEASE_VERSION = 162,

    // Description: User is able to access Errors
    // ClaimName: null Position: 159
    // Feature Id: 159 Position: 159
    RIS2_ACCESS_ERRORS = 159,

}
